import { z } from 'zod'
import { ReboundOrder, ReboundReturns, Returns } from '../types'
import { mapSizes } from '../mappers/mappedReboundApiToReturn'
import {
  ReturnMethod,
  ZReturnsEntry,
  ZReturnsUnion
} from '../validators/returnSchema'
import { objectKeys } from '@helpers/utils'
import { mapReboundSaleItemToReturnProduct } from '../mappers/mapReboundSaleItemToReturnProduct'
import { formatZodError } from './zodErrorFormatter'

export async function buildLegacyReturnsObject(
  returnedItems: ReboundReturns | undefined,
  newResp: ReboundOrder
): Promise<Returns | Record<string, never>> {
  if (!returnedItems || !objectKeys(returnedItems).length) return {}

  const legacyReturn: Record<string, z.infer<typeof ZReturnsEntry>> = {}

  Object.values(returnedItems).map(async container => {
    Object.values(container).map(async ({ products, labelUrl }) => {
      {
        products.map(product => {
          if (!product) return

          const { productType } = product
          const returnedCreatedAt = product.return.returnDate

          const return_id = product.returnId

          if (!legacyReturn[return_id]) {
            legacyReturn[return_id] = {
              products: [],
              return_date: returnedCreatedAt,
              label_url: labelUrl
            }
          }

          const baseProduct = mapReboundSaleItemToReturnProduct(
            product,
            newResp
          )

          legacyReturn[return_id].products.push({
            ...baseProduct,
            return: {
              method: product.return.method as ReturnMethod,
              reason: product.return.reason ? Number(product.return.reason) : 0,
              sizes: mapSizes(productType, product.sizes),
              return_date: returnedCreatedAt,
              return_id,
              reason_detail: [],
              color: product?.return?.color && {
                product_id: Number(product?.return?.color.productId),
                title: product?.return?.color.title,
                image: product?.return?.color.image
              }
            }
          })
        })
      }
    })
  })

  const parsed = ZReturnsUnion.safeParse(legacyReturn)
  if (!parsed.success) {
    const formatted = formatZodError(parsed.error, legacyReturn)
    console.error(
      'Zod validation failed for legacy returns object:\n' + formatted
    )
    throw new Error('Invalid legacy returns object')
  }

  return parsed.data
}
